import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    content: {
        width: rem("100%"),
    },
    item: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: theme.spacing.xl,
        "&[data-active]": {
            backgroundColor: "transparent",
        },
        "& .mantine-Accordion-control": {
            paddingLeft: 0,
            alignSelf: "flex-start",
        },
        "& .mantine-Accordion-chevron": {
            marginLeft: 0,
        },
        "& .mantine-Accordion-content": {
            padding: 0,
        },
    },
    title: {
        "& .mantine-Accordion-label": {
            padding: "0.5rem 0",
            lineHeight: "0.875rem",
            fontWeight: 400,
            fontSize: "0.875rem",
        },
        width: "auto",
    },
}))
